/* eslint-disable */
import Component from 'gia/Component'
import slick from 'slick-carousel'
import slickLightbox from 'slick-lightbox'

export default class ComponentGallerySlider extends Component {
  constructor(element) {
    super(element)
  }

  gallerySliderSetup() {
    $(this.element).each(function() {
      console.log(this)
      $(this)
        .find('.gallery-wrapper')
        .slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        })
    })
  }

  mount() {
    this.gallerySliderSetup()
  }
}



// WEBPACK FOOTER //
// ./scripts/components/GallerySlider.js